(function () {
  function isCustomizerPage() {
    const path = window.location.pathname;
    return path.includes('customize-dog-collar') || 
           path.includes('customize-cat-collar') || 
           path.includes('customize-dog-bandanas') || 
           path.includes('customize-dog-leashes') || 
           path.includes('dog-harnesses') || 
           path.includes('martingale-dog-collars');
  }

  function updateActiveState(productType) {
    if (!isCustomizerPage()) return;
    const iframe = document.getElementById("myIframe");
    if (!iframe) return;

    const urlParams = new URLSearchParams(window.location.search);
    const activeProduct = productType || urlParams.get('product') || urlParams.get('type') || "dog-collar";

    document.querySelectorAll('a[data-product-type]').forEach(a => {
      const type = a.getAttribute('data-product-type');
      const li = a.closest('li');

      if (type === activeProduct) {
        a.classList.add('is-active');
        if (li) li.classList.add('site-nav--active');
      } else {
        a.classList.remove('is-active');
        if (li) li.classList.remove('site-nav--active');
      }
    });

    // Also highlight the "SHOP" parent menu if any child is active
    document.querySelectorAll('.site-nav__item').forEach(li => {
      if (li.textContent.includes('SHOP')) {
        const hasActiveChild = li.querySelector('.is-active');
        if (hasActiveChild) li.classList.add('site-nav--active');
      }
    });
  }

  function sendRouteChange(productType) {
    const iframe = document.getElementById("myIframe");

    if (!isCustomizerPage() || !iframe || !iframe.contentWindow) {
      // Not on the customizer page — redirect with product param
      window.location.href = `/pages/customize-dog-collar?product=${productType}`;
      return;
    }

    // Build consistent message data with flags
    const message = {
      type: 'ROUTE_CHANGE',
      productType: productType
    };

    if (productType === 'cat-collar') {
      message.cat = true;
    } else if (productType === 'dog-leash') {
      message.leash = true;
    } else if (productType === 'martingale-collar') {
      message.martingale = true;
    } else if (productType === 'dog-harness') {
      message.harness = true;
    } else if (productType === 'dog-bandana') {
      message.bandana = true;
    }

    // On the customizer page — send postMessage for smooth switching
    iframe.contentWindow.postMessage(message, '*');

    // Update URL with product parameter and clear incompatible params
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('product', productType);

    // Clear hardware if it's breakaway and we're moving to a dog product
    if (productType !== 'cat-collar' && newUrl.searchParams.get('hardware') === 'breakaway') {
      newUrl.searchParams.delete('hardware');
    }
    
    // Clear leash_length if we're moving AWAY from a leash
    if (productType !== 'dog-leash' && productType !== 'cat-leash') {
      newUrl.searchParams.delete('leash_length');
    }

    history.pushState({ productType: productType }, '', newUrl.toString());

    updateActiveState(productType);

    // Close desktop dropdown
    document.querySelectorAll('details.site-nav__details[open]').forEach(d => {
      d.removeAttribute('open');
    });

    // Close mobile menu
    if (typeof closeMenu === 'function') closeMenu();
  }

  window.navUpdateIframe = sendRouteChange;

  document.addEventListener('DOMContentLoaded', function () {
    updateActiveState();
  });

  // ── CAPTURE PHASE (true) ────────────────────────────────────────────────
  // Fires before any bubble-phase handlers (theme.js, etc.)
  document.addEventListener('click', function (e) {
    const wishlistLink = e.target.closest('a.site-nav__link--wishlist');
    if (wishlistLink && isCustomizerPage()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      
      // Close open navigation dropdowns and mobile menu
      document.querySelectorAll('details.site-nav__details[open]').forEach(d => {
        d.removeAttribute('open');
      });
      if (typeof closeMenu === 'function') closeMenu();

      const iframe = document.getElementById("myIframe");
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({ type: 'OPEN_WISHLIST_MODAL' }, '*');
      }
      return;
    }

    const link = e.target.closest('a[data-product-type]');
    if (!link) return;

    const productType = link.getAttribute('data-product-type');
    const iframe = document.getElementById("myIframe");

    if (!isCustomizerPage() || !iframe || !iframe.contentWindow) {
      // Not on the customizer page.
      // The link has a real href="/pages/customize-dog-collar?product=..."
      // so let the browser navigate naturally — no JS needed.
      if (typeof closeMenu === 'function') closeMenu();
      return;
    }

    // On the customizer page — intercept and do postMessage (no page reload)
    e.preventDefault();
    e.stopImmediatePropagation();
    sendRouteChange(productType);
  }, true); // capture phase

})();